
import ResponsiveDialog from "../dialogs/responsive-dialog.vue";
import ReportItemWiseSalesDetails from "../report/report-item-wise-sales-details.vue";
export default {
  components: {
    ResponsiveDialog,
    ReportItemWiseSalesDetails
  },
  props: {
    dialog: Boolean,
    sortedItems: {
      type: Array,
      default: () => []
    },

    selectedIndex: {
      type: Number,
      default: ""
    }
  }
};
